if (!customElements.get('style-video-modal')) {
  customElements.define(
    'style-video-modal',
    class StyleVideoModal extends ModalDialog {
      constructor() {
        super();
      }

      show(opener) {
        super.show(opener);
        // Load and play the video immediately, as part of the same click that
        // opened the modal, instead of requiring a second click on the poster.
        const deferredMedia = this.querySelector('deferred-media');
        if (deferredMedia && typeof deferredMedia.loadContent === 'function') {
          deferredMedia.loadContent();
        }
      }
    }
  );
}
